import PropTypes from "prop-types";
import { useEffect } from "react";
const ViewPDF = ({ data, length, type = "application/pdf" }) => {
  if (!data) {
    return (
      <div className="col-lg-8">
        <div className="alert alert-danger" role="alert">
          Loading...
        </div>
      </div>
    ); // Gestisci la situazione in cui i dati non sono ancora disponibili
  }

  return (
    <div className="col-lg-8">
      {length > 20 ? (
        <object
          width="100%"
          height="900"
          data={data} // Assicurati che data sia un URL dati valido
          type={type}
        >
          <p>
            Il browser non supporta l'anteprima del PDF. Puoi scaricare il file
            <a href={data} download="document.pdf">
              {" "}
              qui
            </a>
            .
          </p>
        </object>
      ) : (
        <div className="alert alert-danger" role="alert">
          Non è stato caricato nessun PDF
        </div>
      )}
    </div>
  );
};

// Validazione dei prop per evitare errori
ViewPDF.propTypes = {
  data: PropTypes.string.isRequired, // Deve essere un URL valido
  length: PropTypes.number.isRequired, // La lunghezza dei dati
  type: PropTypes.string, // Il tipo MIME del file
};

export default ViewPDF;
